import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { buildQueryParams } from "@/shared/utils/utils";

export const catchmentApi = api
  .enhanceEndpoints({
    addTagTypes: ["CatchmentApi"],
  })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      getCatchment: builder.query({
        query: ({ branch_filter }) => ({
          url: `catchment?catchment_page=campaigns&branch_filter=${branch_filter}`,
          method: RequestMethod.GET,
        }),
        providesTags: (result) => (result ? [{ type: "CatchmentApi" }] : []),
      }),

      createCatchment: builder.mutation({
        query: (data) => ({
          url: `catchment/create`,
          method: RequestMethod.POST,
          body: data,
        }),
        invalidatesTags: [{ type: "CatchmentApi" }],
      }),

      updateCatchment: builder.mutation({
        query: (data) => ({
          url: `catchment/update`,
          method: RequestMethod.POST,
          body: data,
        }),
        invalidatesTags: [{ type: "CatchmentApi" }],
      }),
      getCampaignsCatchment: builder.query({
        query: (params) => ({
          url: `campaigns`,
          method: RequestMethod.GET,
          params: buildQueryParams(params),
        }),
      }),
      updateCampaigns: builder.mutation({
        query: ({ body, campaignId }) => ({
          url: `campaigns/${campaignId}`,
          method: RequestMethod.PUT,
          body: body,
        }),
      }),
      createCampaigns: builder.mutation({
        query: ({ body }) => ({
          url: `campaigns`,
          method: RequestMethod.POST,
          body: body,
        }),
      }),
      getCampaignById: builder.query({
        query: ({ campaignId }) => ({
          url: `campaigns/${campaignId}`,
          method: RequestMethod.GET,
        }),
      }),
    }),
  });

export const {
  useGetCatchmentQuery,
  useCreateCatchmentMutation,
  useUpdateCatchmentMutation,

  // new REST endpoints
  useGetCampaignsCatchmentQuery,
  useCreateCampaignsMutation,
  useGetCampaignByIdQuery,
  useUpdateCampaignsMutation,
} = catchmentApi;
